/* TagFly cross-domain hand-off: carry Google click IDs from one storefront
   domain to its sibling domain so the pixel on the destination sees ?gclid=. */
(function () {
  var SIBLINGS = ['originprima.com', 'hollisticreviews.com'];
  var PARAMS = ['gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid'];
  var KEY = 'tf_handoff';
  var TTL_MS = 90 * 24 * 60 * 60 * 1000;

  function host(h) {
    return String(h || '').toLowerCase().replace(/^www\./, '');
  }

  var here = host(location.hostname);
  if (SIBLINGS.indexOf(here) === -1) return;

  function load() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.params || Date.now() - data.at > TTL_MS) {
        localStorage.removeItem(KEY);
        return null;
      }
      return data.params;
    } catch (e) {
      return null;
    }
  }

  function save(params) {
    try {
      localStorage.setItem(KEY, JSON.stringify({ params: params, at: Date.now() }));
    } catch (e) {}
  }

  // 1. Capture click IDs from the landing URL (the ad lands with ?gclid=...).
  var incoming = new URLSearchParams(location.search);
  var found = {};
  var hasAny = false;
  PARAMS.forEach(function (p) {
    var v = incoming.get(p);
    if (v) {
      found[p] = v;
      hasAny = true;
    }
  });
  if (hasAny) save(found);

  // 2. Rewrite links that point at a sibling domain so they carry the IDs.
  function decorate(a) {
    var params = load();
    if (!params) return;
    var url;
    try {
      url = new URL(a.href, location.href);
    } catch (e) {
      return;
    }
    var target = host(url.hostname);
    if (target === here || SIBLINGS.indexOf(target) === -1) return;
    var changed = false;
    Object.keys(params).forEach(function (k) {
      if (!url.searchParams.has(k)) {
        url.searchParams.set(k, params[k]);
        changed = true;
      }
    });
    if (changed) a.href = url.toString();
  }

  function onEvent(e) {
    var el = e.target;
    if (!el || typeof el.closest !== 'function') return;
    var a = el.closest('a[href]');
    if (a) decorate(a);
  }

  // pointerdown runs before gtag's own linker (mousedown), click/keydown cover
  // keyboard activation and any href reset in between.
  ['pointerdown', 'click', 'keydown'].forEach(function (type) {
    document.addEventListener(type, onEvent, true);
  });
})();